(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (evt) {
      const button = evt.target.closest('.product-form__submit');
      if (!button) return;

      const productForm = button.closest('product-form[data-button-action="checkout"]');
      if (!productForm) return;

      document.body.classList.add('disabled-upcart');

      window.upcartSubscribeAddedToCart(function(event) {
        window.location.href = '/checkout';
      });    
    },
    true
  );
})();
